import { FILTER_VALUE_SEPARATOR } from '@aibees/elephant/constants/filters';
import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { SearchMatchType } from '@aibees/elephant/types';
import { useMemo } from 'react';

export function useExactMatchSelected(
  field: string,
  defaultType?: SearchMatchType
) {
  const { params } = useSearchQueryFilter({ select: [field, 'exact_match'] });
  return useMemo(() => {
    const draft = params.exact_match?.split(FILTER_VALUE_SEPARATOR) ?? [];
    const fieldDraft = draft.find((x) => x.includes(field));
    return fieldDraft?.includes(SearchMatchType.WORD)
      ? SearchMatchType.WORD
      : fieldDraft?.includes(SearchMatchType.STRICT)
      ? SearchMatchType.STRICT
      : fieldDraft?.includes(SearchMatchType.SMART)
      ? SearchMatchType.SMART
      : defaultType;
  }, [params.exact_match, defaultType, field]);
}
